import React from 'react';
import { Link } from 'react-router-dom';

import './styles.scss';

const NotFound = () => {
    return (
        <div className="not-found">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-6 col-md-7">
                        <div className="text-center">
                            <h1 className="display-1 text-primary">40️⃣4</h1>
                            <p>
                                A página que você está buscando não foi encontrada.
                            </p>
                            <Link to="/">Clique aqui para ir a tela inicial</Link>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;